import * as React from "react";
import {  useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import {  Typography, Grid, IconButton, CircularProgress, TextField, Autocomplete} from "@mui/material";
import { Box } from "@mui/system";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useGetAllSavedLayoutsForAdminQuery, useGetLayoutsEngagementByUserQuery } from "../../Slices/roomNateApis";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import CardDetails from "../CardDetails";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


export default function UserEngagement({user}) {

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [floorPlan, setFloorPlan] = useState(null);



  const { isLoading: isEngagementDataLoading, data: engagementData } = useGetLayoutsEngagementByUserQuery(
    {
      userId: user?._id,
      layout: floorPlan?.value,
      startDate,
      endDate
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  
  const {  data: layoutsData } = useGetAllSavedLayoutsForAdminQuery(user?._id);


  if (isEngagementDataLoading)
    return (
      <Box
        position={"absolute"}
        top={"50%"}
        left={"50%"}
        sx={{
          transform: "translate(-50% , -50%)",
          width: "100%",
          textAlign: "center",
          color: "#3C3C4399",
          letterSpacing: "-0.43px",
          fontSize: "17px",
        }}
      >
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <IconButton color="inherit">
            <CircularProgress size={19} color="inherit" />
          </IconButton>
          <Typography ml={1} color={"inherit"}>
            Loading
          </Typography>
        </Box>
      </Box>
    );
  
  return (
    <>
      <TableContainer component={Paper}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 2,
            px: 2,
          }}
        >
          <Typography variant="h6" component={"h6"}>
            {user?.name}
          </Typography>

        </Box>

        <Box sx={{ pt: 2, px: 2 }}>
          <Typography variant="h6" component={"h6"} flexGrow={1}>
            Search Filter
          </Typography>

          <Grid container spacing={2} style={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  sx={{ ".MuiFormControl-root": { width: "100%" } }}
                >
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    slotProps={{
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  sx={{ ".MuiFormControl-root": { width: "100%" } }}
                >
                  <DatePicker
                    label="End Date"
                    minDate={startDate}
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    slotProps={{
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
          </Grid>

          <br></br>

          <Grid item xs={12} sm={6}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                value={floorPlan}
                options={
                  layoutsData
                    ?.filter((layout) => layout?.payload)
                    ?.map((layout) => ({
                      label: layout?.name || "",
                      value: layout?._id || "",
                    })) || []
                }
                getOptionLabel={(option) => option?.label ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                fullWidth
                onChange={(_, value) => setFloorPlan(value)}
                renderOption={(props, option) => {
                  const { key: _muiKey, ...other } = props;
                  return (
                    <li key={option.value} {...other}>
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Floor Plan" />
                )}
              />
          </Grid>
        </Box>

        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            padding: "20px"

        }}>
          <CardDetails title="Last Login" value={new Date(user?.last_login).toLocaleDateString('en-GB')}/>
          <CardDetails title="Login Frequency" value={engagementData?.metricCards?.loginFrequency}/>
        </Box>


        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            padding: "20px"

        }}>
          <CardDetails title="Floor Plan" value={engagementData?.metricCards?.totalLayouts}/>
          <CardDetails title="Projects"  value={engagementData?.metricCards?.totalFolders}/>
          <CardDetails title="Versions" value={engagementData?.metricCards?.totalVersions}/>
          <CardDetails title="Downloads" value={engagementData?.metricCards?.totalDownloads}/>
        </Box>

        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            padding: "20px"

        }}>
          <CardDetails title="Shares" value={engagementData?.metricCards?.totalShares}/>
          <CardDetails title="Score" value={engagementData?.metricCards?.totalLayouts * 1 + engagementData?.metricCards?.totalShuffles*2 || 0}/>
        </Box>
        
          <BarChart engagementsData={engagementData} />
      </TableContainer>
      <br/>
      <br/>

     
    </>
  );
}



const BarChart = ({engagementsData}) => {
  const data = {
    labels: [''], 
    datasets: [
      {
        label: 'Projects',
        data: [engagementsData?.metricCards?.totalFolders],
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
        borderColor: 'rgba(153, 102, 255, 1)', 
        borderWidth: 1,
      },
      {
        label: 'Downloads',
        data: [engagementsData?.metricCards?.totalDownloads], 
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        label: 'Shares',
        data: [engagementsData?.metricCards?.totalShares], 
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
      {
        label: 'Shuffle',
        data: [engagementsData?.metricCards?.totalShuffles],
        backgroundColor: 'rgba(255, 159, 64, 0.2)',
        borderColor: 'rgba(255, 159, 64, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Bar data={data} options={options} />;
};



